function asyncScripts(scripts) {
    scripts.forEach(function(el) {
        // If we can find the selector, append the script
        if (document.querySelector(el.selector) !== null) {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = el.url;
            document.body.appendChild(s);
        }
    });
}

export {
	asyncScripts,
};